export default "__VITE_ASSET__6c98e130__"